<header *ngIf="title">
  <h1>{{title}}</h1>
</header>

<ng-container *ngIf="content" (click)="onBodyClick($event)">
  <div [innerHTML]="content | safeHtml"></div>
</ng-container>
